<template>
    <div>
      <FormulaBanner :formulaCode="formulaCode" :title="title"/>
      <div class="index">
        <!-- 表单 -->
        <div>
          <div class="top_nav"><span></span>{{ title }}
          </div>
          <div class="formBody">
            <!-- 表单 -->
            <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
  
            <TemplateFiveList :list-data="listData" :selectValue="listSelect" :type="'check'"
                              @change="listChange"></TemplateFiveList>
            <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
              <van-button block class="formula-template-button" type="info" @click="submit" style="width:90px">提交</van-button>
            </div>
            <!--          <div v-if="countText || countText !== ''" class="CalculationResultsBox">-->
            <!--            <div class="CalculationResults"><span>计算结果</span></div>-->
            <!--            &lt;!&ndash; 具体标准 &ndash;&gt;-->
            <!--            <div>-->
            <!--              <div class="CalculationDetail"><span></span>{{ result }}分 {{ countText }}</div>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
        </div>
        <CalculationResults :countText="countValue" :countTextList="countTextList" v-if="show"></CalculationResults>
        <!-- 后台设置的值 -->
        <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
        <!-- 参考文献 -->
        <FormulaReferences :references-data="tableData.references"></FormulaReferences>
      </div>
  
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            :columns="columns"
            show-toolbar
            title="应激指数"
            @cancel="onCancel"
            @confirm="onConfirm"
        />
      </van-popup>
  
    </div>
  
  </template>
  
  <script>
  import MyPatient from '@/components/MyPatient.vue'
  import FormulaBanner from '@/components/FormulaBanner.vue'
  import {Toast} from "vant";
  import {getAdmins} from "@/utils/adminDate";
  import {setById} from "@/service/base";
  import {getFormula, getFormulaHuiXian,postFormula } from "@/service/BodyMassIndex_api";  
  import FormulaExplain from "@/components/template1/FormulaExplain";
  import FormulaReferences from "@/components/template1/FormulaReferences";
  import TemplateFiveList from "@/components/Template5/TemplateFiveList";
  import CalculationResults from "@/components/CalculationResults.vue";
  
  export default {
    name: "medicalSearch",
    data() {
      return {
        compute:true,
        show:false,
        listSelect: [],
        listData: [
          {
            title: '标准监测',
            columns: ['每小时生命体征、液体平衡的常规记录和计算', '实验室检查  生化和微生物检查', '单一药物静脉、肌内、皮下注射和（或）口服（例如经胃管给药）','静脉使用多种药物  单次静脉或持续输注1种以上药物','常规更换敷料  压疮的护理和预防，每日更换一次敷料','频繁更换敷料（每个护理班至少更换一次）和（或）大面积伤口护理','引流管的护理  除胃管以外的所有导管的护理'],
            fenzhi: [5,1,2,2,3,1,1] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '通气支持',
            columns: ['机械通气  任何形式的机械通气/辅助通气，无论是否使用PEEP或肌松药；加用PEEP的自主呼吸', '经气管插管自主呼吸，不应用PEEP；除机械通气外，任何形式的氧疗', '人工气道的护理  气管插管或气管切开的护理','肺部理疗，刺激性肺量计、吸入疗法、气管内吸痰'],
            fenzhi: [5,5,2,1] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '心血管支持',
            columns: ['单一血管活性药物  使用任何血管活性药物', '多种血管活性药物  使用一种以上的血管活性药物，不论种类和剂量', '静脉补充丢失的大量液体<br/>\n输液量>3L/（m²·d），不论液体种类和剂量','放置外周静脉导管','左心房监测  放置肺动脉漂浮导管，不论是否测量心排出量','中心静脉置管','在过去24小时内进行过心跳骤停后心肺复苏（单次心前区叩外）'],
            fenzhi: [3,3,4,5,8,2,3] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '肾脏支持',
            columns: ['血液滤过 ，血液透析', '定量测定尿量（经导尿管测量）', '积极利尿【例如呋塞米>0.5mg/（kg·d）治疗液体超负荷】'],
            fenzhi: [3,2,3] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '神经系统支持',
            columns: ['颅内压监测'],
            fenzhi: [4] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '代谢支持',
            columns: ['复杂性代谢性酸中毒或碱中毒的治疗', '静脉营养支持', '胃肠内营养   经胃管或其他胃肠道途径（例如空肠造瘘）'],
            fenzhi: [3,4,2] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '特殊干预措施',
            columns: ['ICU内单一特殊干预措施  经鼻或口气管插管、放置起搏器、心律转复内经检查、过去24小时内急诊手术、洗胃。对患者临床情况不产生直接影响的常规干预措施。如X线检查、超声检查、心电图检查、更换敷料、放置静脉或动脉导管等不包括在内', 'ICU内多种特殊干扰措施  上述项目中一种以上的干预措施', 'ICU外的特殊干预措施  手术或诊断性操作'],
            fenzhi: [3,5,5] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
        ],
        formulaCode: '',
        shengao: '',
        yingjizhishu: '',
        title: '',
        memberId: '1111',
        selectValue: '',
        username: "",
        value: "",
        showPopover: false,
        showPicker: false,
        columns: ['立即治疗', '加强监测', '维持和监护'],
        nianling: '',
        xingbie: null,
        tableData: {},
        countText: '',
        patientId: null,
        result: null,
        yingjizhishuzhi: '',
        tizhong: '',
        xueqingnanongdu: '',
        fenzhiList: [],
        countValue:"",
        countTextList:[],
      }
    },
    components: {
      CalculationResults,
      FormulaBanner,
      MyPatient,
      FormulaExplain,
      FormulaReferences,
      TemplateFiveList,
    },
    async created() {
      await this.test()
      await this.getTableData()
    },
  
    methods: {
      listChange(result, fenzhi) {
        this.show=false
        this.listSelect = result //结果数组
        this.fenzhiList = fenzhi  //分值数组
        // 选项互斥
        result.map((item ,index ) => {
          if(item.title === '标准监测' && item.value.length !== 0){
            // console.log(this.listSelect[index])
            // 如果选项选择了3，接着又选择了4，就移除3;如果先选了4，又选了3，就移除4
            this.listSelect[index].value.forEach(item => {
              if(item === '单一药物静脉、肌内、皮下注射和（或）口服（例如经胃管给药）'){
                // 如果这时候又选择了4，就删除3选项
                if(this.listSelect[index].value.includes("静脉使用多种药物  单次静脉或持续输注1种以上药物")){
                    this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                    return item !== "单一药物静脉、肌内、皮下注射和（或）口服（例如经胃管给药）"
                  });
                }
              }else if(item === '静脉使用多种药物  单次静脉或持续输注1种以上药物'){
                if(this.listSelect[index].value.includes("单一药物静脉、肌内、皮下注射和（或）口服（例如经胃管给药）")){
                    this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                    return item !== "静脉使用多种药物  单次静脉或持续输注1种以上药物"
                  });
                }
              }
            })
          }else if(item.title === '通气支持' && item.value.length !== 0){
            // 1和2互斥
            this.listSelect[index].value.forEach(item => {
              var option1 = this.listData[1].columns[0]
              var option2 = this.listData[1].columns[1]
              if(item === option1){
                if(this.listSelect[index].value.includes(option2)){
                    this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                    return item !== option1
                  });
                }
              }else if(item === option2){
                  if(this.listSelect[index].value.includes(option1)){
                      this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                      return item !== option2
                    });
                  }
              }
            })
          }else if(item.title === '心血管支持' && item.value.length !== 0){
            // 1和2互斥
            this.listSelect[index].value.forEach(item => {
              var option1 = this.listData[2].columns[0]
              var option2 = this.listData[2].columns[1]
              if(item === option1){
                if(this.listSelect[index].value.includes(option2)){
                    this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                    return item !== option1
                  });
                }
              }else if(item === option2){
                  if(this.listSelect[index].value.includes(option1)){
                      this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                      return item !== option2
                    });
                  }
              }
            })
          }else if(item.title === '特殊干预措施' && item.value.length !== 0){
            // 1和2互斥
            this.listSelect[index].value.forEach(item => {
              var option1 = this.listData[6].columns[0]
              var option2 = this.listData[6].columns[1]
              if(item === option1){
                if(this.listSelect[index].value.includes(option2)){
                    this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                    return item !== option1
                  });
                }
              }else if(item === option2){
                  if(this.listSelect[index].value.includes(option1)){
                      this.listSelect[index].value = this.listSelect[index].value.filter(function(item) {
                      return item !== option2
                    });
                  }
              }
            })
          }
        })
      },
      coumputTetxt() {
        this.show=true
        let fenshu = 0
        function calculateScore(data, select) {
          select.value.forEach(item => {
            const index = data.columns.indexOf(item);
            if (index !== -1) {
              fenshu += data.fenzhi[index];
            }
          });
        }
  
        this.listSelect.forEach(value => {
          const data = this.listData.find(d => d.title === value.title);
          if (data) {
            calculateScore(data, value);
          }
        });


        // 评分＜10分，Ⅰ级，病情稳定，接受无创观察
        // 评分10-19分，Ⅱ级，病情稳定，接受有创观察和一些治疗措施
        // 评分20-39分，Ⅲ级，病情不稳定，接受有创观察和治疗，无立即生命危险
        // 评分40分，Ⅳ级，病情不稳定，接受有创观察及生命支持治疗，有立即生命危险


        if ( fenshu< 10) {
          this.countText = 'Ⅰ级 病情稳定，接受无创观察'
        } else if (10 <= fenshu && fenshu < 19) {
          this.countText = 'Ⅱ级 病情稳定，接受有创观察和一些治疗措施'
        } else if (20 <= fenshu && fenshu < 39 ) {
          this.countText = 'Ⅲ级 病情不稳定，接受有创观察和治疗，无立即生命危险'
        }else if ( fenshu >= 40 ) {
          this.countText = 'Ⅳ级 病情不稳定，接受有创观察及生命支持治疗，有立即生命危险'
        }
        this.result = fenshu
        this.countValue = `${fenshu}分 ${this.countText}`
      },
      async test() {
        //像接口头部传用户信息
        let arrays = await getAdmins(this.$route.query.memberId, this.$route.query.channel)
        this.channel = arrays.os
        this.version = arrays.version
        this.ip = arrays.ip
        await setById(arrays)
      },
      async getTableData() {
        const data = {
          channel: this.$router.currentRoute.query.channel,
          code: 'BCKZUZGG',
        }
        const res = await getFormula(data.channel, data.code)
        if (res.code === 0) {
            console.log("数据",res.data)
          this.tableData = res.data
          this.formulaCode = res.data.code
          this.title = res.data.chineseName
        }
        if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
        
          const data = {
            id: this.$router.currentRoute.query.logId
          }
          const res = await getFormulaHuiXian(data)
          if (res.code === 0) {
            this.listSelect = res.data.content.data
            if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
            this.result = res.data.result.value
            this.countText = res.data.result.result
            this.countValue = `${res.data.result.value}分 ${res.data.result.result}`
            this.show=true
            // this.coumputTetxt()
          }
        }
      },
      async submit() {
        // if (!this.listSelect.length || this.listSelect.length === 0) {
        //   Toast.fail('请至少选择一项')
        //   return
        // }
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
          columnCode:0, //属于常用公式
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            data: this.listSelect,
          },
          result: {
            value: this.result,
            result: this.countText,
            DisplayResults:this.countValue
          }
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
        } else {
          Toast.fail(res.message)
        }
      },
      calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        // 如果今天的日期还没到生日月份和日期，则年龄减一
        if (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      // 开参考文献链接
      openLink(u) {
        if (!u) {
          return
        }
        //获取系统版本
        let userAI = navigator.userAgent;
        const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
        const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          // alert('安卓操作系统')
          // 这个是安卓操作系统
          window.open(u)
        }
        if (isIOS) {
          // 这个是ios操作系统
          // alert('ios操作系统')
          window.location.href = u
        }
      },
      yingjiClick() {
        this.showPicker = true
      },
      onConfirm(value) {
        this.yingjizhishu = value
        this.showPicker = false
      },
      onCancel() {
        this.showPicker = false
      },
      userChange(data) {
        if (data.birthday && data.birthday !== '') {
          this.nianling = this.calculateAge(data.birthday)
        } else {
          this.nianling = ''
        }
        this.xingbie = data.sex
        this.patientId = data.id
        this.selectValue = data
      },
    }
  }
  </script>
  
  
  <style lang="scss" scoped>
  //::v-deep .box-div-dis-zi{
  //  margin: 12px 0 !important;
  //}
  .index {
    background: #F6F6F6;
    padding: 10px 15px;
    min-height: 100vh;
  
    .StandardDescription {
      margin-top: 10px;
  
      .top_nav {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom: 10px;
  
        span {
          display: inline-block;
          width: 5px;
          height: 15px;
          background: #259beb;
          margin-right: 5px;
        }
      }
  
      .StandardDeatil {
        width: 100%;
        padding: 15px 10px;
        //   height: 50px;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
  
    .top_nav {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom: 10px;
  
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
  
    .formBody {
      background-color: #fff;
      padding-bottom: 10px;
  
      .CalculationResultsBox {
        padding: 0 8px;
  
        .CalculationResults {
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          margin-bottom: 10px
        }
  
        .CalculationDetail {
          font-size: 15px;
          color: #333333;
          // font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom: 10px;
          background-color: #f6f6f6;
          // height: 16px;
          span {
            display: inline-block;
            width: 3px;
            height: 24px;
            background: #fe9712;
            margin-right: 5px;
          }
        }
      }
    }
  
    .titles {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 10px;
      box-sizing: border-box;
  
      .titlesName {
        font-size: 16px;
  
        i {
          color: red;
        }
      }
  
      .information {
        font-size: 16px;
        margin-right: 4px;
  
        .PleaseSelect {
          color: #b9b9b9;
        }
  
        .vanCell {
          width: 50px;
          padding: 0;
          height: 100%;
        }
      }
  
      .vBotton {
        width: 60px
      }
  
      .unit {
        height: 50px;
        //   line-height: 50px;
        display: flex;
        align-items: center;
        font-size: 16px;
        width: 20px;
      }
  
      .vanIcon {
        font-size: 13px;
        color: #a8a8a8;
        font-weight: 650;
      }
    }
  }
  
  ::v-deep .van-cell {
    padding: 0px 0px;
  }
  
  ::v-deep .van-field__control {
    height: 50px;
    font-size: 16px;
  }
  
  ::v-deep .van-field__error-message {
    position: absolute;
    top: 30px;
    left: 10px;
  }
  
  .StandardDeatil2 {
    width: 100%;
    padding: 15px 10px;
    padding-bottom: 1px;
    //   height: 50px;
    background-color: #fff;
    box-sizing: border-box;
  
    .references {
      margin-bottom: 15px
    }
  }
  
  ::v-deep p {
    padding: 0;
    margin: 0;
  }
  
  .Abutton {
  
  }
  </style>
  